import Button from 'common/components/button';
import LogoImage from 'common/components/logo-image';
import { backgroundTypeEnum } from 'common/utils/enums';

const AuthAsideLayout = ({
  children,
  onClick,
  backgroundType = backgroundTypeEnum.BACKGROUND_LIGHT,
  bgColor,
  bgImage,
  logo = '',
}) => {
  return (
    <aside
      className={`h-full justify-center relative flex`}
      style={{ backgroundColor: bgColor }}
    >
      {/* mesh bg */}
      {bgImage ? (
        <img
          src={bgImage}
          alt='Property Signup Page background Image'
          className='absolute top-0 left-0 w-full h-full z-0 object-cover opacity-10'
        />
      ) : !bgColor ? (
        <img
          src='/images/login/side-bg.png'
          alt='aside mesh bg'
          className='absolute top-0 left-0 w-full h-full z-0 object-cover'
        />
      ) : null}

      {/* wrapper */}
      <div className='flex flex-col gap-10 relative px-6 md:px-8 py-16 max-w-md min-h-screen'>
        {logo ? (
          <div className='flex flex-col gap-4 items-start mb-2'>
            <img
              src={logo}
              alt='Property Logo'
              className='h-auto w-auto max-w-[160px] max-h-[100px]'
            />            
          </div>
        ) : (
          <LogoImage
            dark={backgroundType === backgroundTypeEnum.BACKGROUND_LIGHT}
            size='s'
          />
        )}

        {/* texts */}
        <div className='flex flex-col gap-6'>
          {/* {logo && (
            <span className={`font-lg font-medium tracking-tight text-lg ${
              backgroundType === backgroundTypeEnum.BACKGROUND_LIGHT
                ? 'text-black opacity-60'
                : 'text-white opacity-60'
            }`}>
              Love It or Leave It Guarantee
            </span>
          )} */}
          <p
            className={`font-display tracking-tight text-4xl max-w-sm ${
              backgroundType === backgroundTypeEnum.BACKGROUND_LIGHT
                ? 'text-black'
                : 'text-white'
            }`}
          >
            Get a flexible leasing option from ReLease
          </p>

          <p
            className={`text-lg font-normal ${
              backgroundType === backgroundTypeEnum.BACKGROUND_LIGHT
                ? 'text-black opacity-60'
                : 'text-white opacity-60'
            }`}
          >
            Rent with total peace of mind with a flexible leasing option from ReLease
          </p>

          {/* <Button
            wFull={false}
            title='Get Started'
            onClick={onClick}
            className='hidden mobile:flex mt-2 w-fit'
            theme={
              backgroundType === backgroundTypeEnum.BACKGROUND_LIGHT
                ? 'primary'
                : 'secondary'
            }
          /> */}
        </div>

        {/* children */}
        <div className='flex flex-col gap-4 md:hidden lg:flex'>{children}</div>

        {logo && (
          <div
            className='flex flex-col gap-2 justify-end h-full cursor-pointer'
            onClick={() =>
              window.open('https://releaserent.com/residents', '_blank')
            }
          >
            <span className={`text-sm font-normal ${
              backgroundType === backgroundTypeEnum.BACKGROUND_LIGHT
              ? 'text-black opacity-60'
              : 'text-white opacity-60'
            }`}>
              Powered by
            </span>
            <LogoImage
              dark={backgroundType === backgroundTypeEnum.BACKGROUND_LIGHT}
              size='xs'
            />
          </div>
        )}
      </div>
    </aside>
  );
};

export default AuthAsideLayout;
